export default {
}



// WEBPACK FOOTER //
// ./src/store/modules/getters.js